import { utcToZonedTime } from 'date-fns-tz'
import {
  add,
  addDays,
  addMinutes,
  getHours,
  isAfter,
  isWithinInterval,
  set
} from 'date-fns'

export function addRemoveFromArray(item, itemsArray, shouldAdd) {
  const alreadyInArray = itemsArray.includes(item)
  if (shouldAdd) {
    if (!alreadyInArray) { itemsArray = itemsArray.concat(item) }
  } else {
    if (alreadyInArray) { itemsArray = itemsArray.filter(function (itemInArray) { return itemInArray !== item }) }
  }
  return itemsArray
}

export function addRemoveObject(keyToUpdate, valueObjectToUpdate, objectToUpdate) {
  let updatedObject = objectToUpdate
  const objectIsEmpty = Object.keys(updatedObject).length < 1,
    valueIsEmpty = Object.keys(valueObjectToUpdate).length < 1

  if (objectIsEmpty && valueIsEmpty) {
  } else if (objectIsEmpty && !valueIsEmpty) {
    let updatedObject = {}
    updatedObject[keyToUpdate] = valueObjectToUpdate
    return updatedObject
  } else {
    for (let key in updatedObject) {
      if (key === keyToUpdate) {
        if (valueIsEmpty) {
          delete updatedObject[key]
        } else {
          updatedObject[key] = valueObjectToUpdate
        }
      }
    }
  }
  return updatedObject
}

export function groupBy(arrayToGroup, keyToGroupBy) {
  // from https://stackoverflow.com/questions/14446511
  return arrayToGroup.reduce(function(rv, x) {
    (rv[x[keyToGroupBy]] = rv[x[keyToGroupBy]] || []).push(x);
    return rv;
  }, {})
}

export function isObject(obj) {
  return typeof obj === 'function' || (typeof obj === 'object' && !!obj)
}

export function shortenNumber(number, useCurrency) {
  // from: https://stackoverflow.com/a/55987576
  let n = parseInt(number),
    isDecimal = number > 0 && number < 1,
    isNeg = n < 0,
    absNumber = Math.abs(n),
    shortNumber

  switch (true) {
    case (absNumber >= 1e3 && absNumber < 1e6):
      shortNumber = `${+(absNumber / 1e3).toFixed(1)}k`
      break
    case (absNumber >= 1e6 && absNumber < 1e9):
      shortNumber = `${+(absNumber / 1e6).toFixed(1)}m`
      break
    case (absNumber >= 1e9 && absNumber < 1e12):
      shortNumber = `${+(absNumber / 1e9).toFixed(1)}b`
      break
    case (absNumber >= 1e12):
      shortNumber = `${+(absNumber / 1e12).toFixed(1)}t`
      break
    default:
      shortNumber = isDecimal ? number.toFixed(2) : absNumber
  }

  let currencyNumber = isNeg ? `-$${shortNumber}` : `$${shortNumber}`
  shortNumber = isNeg ? `-${shortNumber}` : shortNumber
  return useCurrency ? currencyNumber : shortNumber
}

/**
 * Calculates the difference from a point on site to the top of an element
 * @param y {number} = A vertical point on the page
 * @param element {object|string} = DOM element or selector
 */
export function spaceBetween(y, element) {
  if(typeof element === 'string') {
    element = document.querySelector(element)
  }

  if(!element) {
    throw new Error(`Unable to find element for selector: ${selector}`)
  }

  const elementTop = element.getBoundingClientRect().top
  return elementTop - y
}
export function isNil(value) {
  return value === null || value === undefined
}

export function formatPhoneNumber(phoneNumberString) {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    return match[1] + '-' + match[2] + '-' + match[3]
  }
  return null
}

/**
 * Pluralize a given string
 * @param {number} value - value to control
 * @param {string} singular - desired singular version of string
 * @param {string} [plural] - desired plural version of string or "s" appended to singular if not provided
 * @returns string
 */

export function pluralize(value, singular, plural = `${singular}s`) {
  return ( isNaN(value) || value <=1 ) ? singular : plural
}

/**
 * Returns the index of the blot when given a domNode
 * @param {string} text - text to be spliced
 * @param {number} index - index to insert text
 * @param {number} replacementString - text to be inserted
 */

export function spliceIntoString(text, index, replacementString){
  return index || index === 0 ? `${text.slice(0,index)} ${replacementString} ${text.slice(index)}` : text;
}

/**
* Returns the next available datetime when checking a given datetime range
* @param {string} timeZone - merchant's time zone
* @param {date} startTime - date object representing the start datetime
* @param {date} endTime - date object representing the end datetime
*/
export function isInDateTimeRangeUtil({timeZone, startHour, endHour, chosenDate = null, addBuffer = false}) {
  const now = chosenDate || utcToZonedTime(new Date(), timeZone),
        startTime = new Date(now.getTime())
  let endTime = new Date(now.getTime())
  startTime.setHours(startHour, 0, 0)
  endTime.setHours(endHour, 0, 0)

  // There are 2 scenarios:
  // If send now, merchant has the full window and 15 minute buffer (i.e. ad has 8PM-9PM, merchant is able to send now in between 8PM-9:15PM)
  // If send later, merchant has the full window without the buffer.
  addBuffer && (endTime = addMinutes(endTime, 15))
  return isWithinInterval(now, { start: startTime, end: endTime })
}

/**
 * Returns true if compare time is within the given time intervale
 * @param {Date} start
 * @param {Date} end
 * @param {Date} compare
 */
export function isWithinTime(start, end, compare) {
  return getHours(start) <= getHours(compare) && getHours(end) > getHours(compare);
}
/**
* Checks if the merchant's current time is in the attached ad's send time range. If not, calculate the next available date time to send the campaign with attached ad.
* No need to worry about ads that start in the future cuz BE won't return those to FE.
* @param {string} timeZone - merchant's time zone
* @param {date} min - the start date of ad with time range (if there is any)
* @param {date} max - the end date of ad with time range (if there is any)
*/
export function getNextAvailableDateTimeUtil(timeZone, min, max) {
  const now = utcToZonedTime(new Date(), timeZone),
        endTime = new Date(now.getTime()),
        startTime = new Date(min.getTime())

  startTime.setHours(0)
  endTime.setHours(max.getHours(), 0, 0)

  const isInAdDateRange = isWithinInterval(now, { start: startTime, end: max })

  let nextAvailableDateTime = now

  if (isInAdDateRange) {
    if (isAfter(now, endTime)) nextAvailableDateTime = add(nextAvailableDateTime, { days: 1 })
    nextAvailableDateTime.setHours(min.getHours(), 0, 0, 0)
  }

  return nextAvailableDateTime
}

/**
 * Removes time zone part from date string aka anything after "Z".
 * @param {string} dateString - ISO string that needs time zone part removed
 */
export function removeTimeZoneAndGetDateUtil(dateString) {
  return dateString ? new Date(dateString.split("Z")[0]) : null
}

/*
 *  Removes http protocol from a given string
 *  @param {string} text - text to be stripped
 */
export function stripHttpProtocolUtil(text) {
  if(!text) return
  return text.replace(/(http|https):\/\//g, "")
}

/**
 * Move an array element from an index to an index
 * @param {array} arr
 * @param {number} fromIndex
 * @param {number} toIndex
 */
export function arrayMoveUtil(arr, fromIndex, toIndex) {
  var arrayElement = arr[fromIndex]
  arr.splice(fromIndex, 1)
  arr.splice(toIndex, 0, arrayElement)
  return arr
}

/**
 * Check if an url starts strictly with http:// or https://
 * @param {string} url
 * @returns {boolean} result of the regex as a boolean
 */
export function isUrlFormatValidUtil(url){
  const regex = new RegExp(/^(http|https):\/\/([a-z]|[A-Z]|[0-9])/g)
  return regex.test(url)
}

/**
 * Returns the next available hour between now and a given TIMErange. Only cares about time component, not date
 * @param range {Object} that contains { min: Date(), max: Date() }
 * @returns {null|Date}
 */
export function nextAvailableHour(range, date) {
  if(range.min.getHours() > date.getHours()) {
    return set(date, {
      hours: range.min.getHours(),
      minutes: 0,
      seconds: 0,
      milliseconds: 0
    });
  } else if(range.max.getHours() <= date.getHours()) {
    const tomorrow = addDays(date, 1);
    return set(tomorrow, {
      hours: range.min.getHours(),
      minutes: 0,
      seconds: 0,
      milliseconds: 0
    });
  }

  return date
}

export function hasEmoji(text) {
  if(typeof text !== 'string') {
    return false;
  }

  const regex = /\uD83C\uDFF4(?:\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74)\uDB40\uDC7F|\u200D\u2620\uFE0F)|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC68(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3])|(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3]))|\uD83D\uDC69\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3])|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\uD83D\uDC68(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|(?:(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)\uFE0F|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDD6-\uDDDD])(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\u200D[\u2640\u2642])|\uD83D\uDC69\u200D[\u2695\u2696\u2708])\uFE0F|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC68(?:\u200D(?:(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D[\uDC66\uDC67])|\uD83C[\uDFFB-\uDFFF])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3])|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC70\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD36\uDDB5\uDDB6\uDDD1-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDEEB\uDEEC\uDEF4-\uDEF9]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD70\uDD73-\uDD76\uDD7A\uDD7C-\uDDA2\uDDB0-\uDDB9\uDDC0-\uDDC2\uDDD0-\uDDFF])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEF9]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD70\uDD73-\uDD76\uDD7A\uDD7C-\uDDA2\uDDB0-\uDDB9\uDDC0-\uDDC2\uDDD0-\uDDFF])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC69\uDC6E\uDC70-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD26\uDD30-\uDD39\uDD3D\uDD3E\uDDB5\uDDB6\uDDB8\uDDB9\uDDD1-\uDDDD])/g;
  return text.replace(regex, '').length !== text.length;
}

/**
 * formatting number by adding comma
 * @param num {number} = number to be formatted
 */
export function commafyNumber(num) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

/**
 * Truncate string with ellipses
 * @param {string} text
 * @param {number} max
 * @param {string} dots
 */
export function truncateWithEllipses(text, max, dots = ' ...') {
  return `${text.slice(0, max)}${text.length > max ? dots : ""}`;
}
